export default "__VITE_ASSET__B9a_ue_b__"